import styled from 'styled-components';

export const Header = styled.div`
  width: 100%;
  margin-top: 0;
  padding: 20px 40px;
  display: flex;
  align-items: baseline;
  justify-content: space-between;

  @media (max-width: 450px) {
    img {
      width: 40%;
      height: 40%;
    }
  }
`;

export const Container = styled.div`
  width: 100%;
  background: #ebf1ed;
  padding: 10px;
  border-radius: 8px;
  img {
    align-self: center;
  }
`;

export const Information = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  h1 {
    padding: 0 10px;
    margin-top: 20px;
    font-size: 18px;
    text-align: center;
  }

  p {
    margin-top: 10px;
    font-weight: 400;
    font-size: 14px;
    line-height: 30px;
    padding: 0 40px;
    margin-bottom: 10px;
    font-weight: 400;
  }

  form {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }

  @media (max-width: 450px) {
    h1 {
      font-size: 14px;
    }

    p {
      line-height: 10px;
      font-size: 12px;
      padding: 0 5px;
    }
  }
`;
